module.exports = __webpack_public_path__ + "static/media/hk-skyline.782f098c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/hk-skyline.jpg
// module id = 298
// module chunks = 0